import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f6b5b90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "flex text-[16] mb-[10px] gap-[40px]" }
const _hoisted_3 = { class: "info-panel" }
const _hoisted_4 = {
  class: "info-panel-item active",
  href: "javascript:void"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-[26px]"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex-1 overflow-hidden whitespace-nowrap text-ellipsis" }

import { withDefaults, ref, computed } from 'vue';
import useNavigation from "@/hooks/useNavigation";
import { IItem } from '@/interface/article.d';
// import type { TabsPaneContext } from 'element-plus'
interface IProps {
    dataList: Array<Partial<IItem>>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationDisclosure',
  props: {
    dataList: { default: () => [{}] }
  },
  setup(__props: any) {

const { push } = useNavigation();

// const 最新公开

const props = __props;

// const activeName = ref<any>(props.dataList[0]?.title);
// const activeName2 = ref<any>(props.dataList[1]?.title);

// activeName计算属性 ref
// const activeNameHTML = computed(() => {
//   return props.dataList?.find(item => item.title === activeName.value)?.content || ''
// })

// activeName计算属性 ref
// const activeName2HTML = computed(() => {
//   return props.dataList?.find(item => item.title === activeName2.value)?.content || ''
// })

// onMounted(() => {
//     setTimeout(() => {
//     }, 2000);
// })

// watch(
//   () => props.dataList,
//   (value) => {
//     if(value) {
        
//     }
//   }
// )

// const handleClick = (tab) => {
//   console.log(tab)
//   activeName.value = tab
// }

// const handleClick2 = (tab) => {
//   console.log(tab)
//   activeName2.value = tab
// }

function goDetail({ id }) {
  push({
    path: "/aboutus/detail",
    query: {
      id,
    },
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "flex-1"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", _hoisted_4, _toDisplayString(item.title), 1)
          ]),
          (item.list?.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (demo) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "doc",
                    key: demo.id,
                    onClick: ($event: any) => (goDetail(demo))
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(demo.title), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})